(function (window, document) {
    if (document.querySelector('.postlist') !== null) {
        var columns = parseInt(document.querySelector('.postlist').getAttribute('data-columns'));
        var offset = parseInt(document.querySelector('.postlist').getAttribute('data-offset'));
        var limit = parseInt(document.querySelector('.postlist').getAttribute('data-limit'));
        var endlessScroll = parseInt(document.querySelector('.postlist').getAttribute('data-endlessscroll')) === 1;
        var loading = false;

        /**
         * Load posts
         *
         */
        function loadPosts() {
            if (loading) {
                return;
            }
            loading = true;

            var url = window._AVENCY_BASE_actions.postList;
            url += '&columns=' + columns;
            url += '&offset=' + offset;
            url += '&limit=' + limit;

            var request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400 && this.response != '') {
                    if (endlessScroll && offset > 0) {
                        var newDom = document.createElement('div');
                        newDom.innerHTML = this.response;
                        document.querySelector('.postlist .postlist-listing').appendChild(newDom);
                    } else {
                        document.querySelector('.postlist .postlist-listing').innerHTML = this.response;
                    }
                    loading = false;
                    offset += limit;
                }
            };
            request.send();
        }

        /**
         * Check if post bottom is in viewport
         *
         * @returns {boolean|boolean}
         */
        function isInViewport() {
            var endlessScrollElement = document.querySelector('.postlist .postlist-endlessscroll');
            var bounding = endlessScrollElement.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        // Load first batch of post
        loadPosts();

        if (endlessScroll) {
            window.addEventListener('scroll', function () {
                if (isInViewport()) {
                    loadPosts();
                }
            });
        }
    }
})(window, document);
